export default "__VITE_ASSET__CSRYYxQi__"